import React, { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { CContainer } from '@coreui/react'
import routes from '../routes'

const AnonymousAppContent = () => {
  const body = (
    <CContainer lg>
      <Suspense>
        <Routes>
          {routes.map((route, idx) => {
            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  element={<route.element />}
                />
              )
            )
          })}
          <Route path="/" element={<Navigate to="dashboard" replace />} />
        </Routes> 
      </Suspense>
    </CContainer>
  )

  return ( body )
}

export default React.memo(AnonymousAppContent)
